import React, { Fragment } from 'react';
import { useParams, Link } from 'react-router-dom';
// import AuthContext from "../../contexts/AuthContext";

export default function ErrorPage(props: any) {
  const params = useParams() as any;
  const errorCode = params.errorCode;

  return (
    <div
      className="error-page-containter"
      style={{ height: window.innerHeight }}
    >
      <div className={'layout'}>
        {parseInt(errorCode) === 700 ? (
          <Fragment>
            <div className={`text icon_500`}></div>
            <div className={`text-700`}>در حال حاضر امکان ورود وجود ندارد</div>
          </Fragment>
        ) : (
          <Fragment>
            <div className={'title'}>{errorCode}</div>
            <div className={`text icon_${errorCode}`}>
              خطای {errorCode ? errorCode : 'CORS'}
            </div>
          </Fragment>
        )}

        <div className="buttons">
          <Link to="/">
            <p className={'text_buttons_intro'}>باز گشت به خانه</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
